import React from 'react';
import {Entity} from 'draft-js';
import '../../css/components/TeXEditor/imageBlock.css';
import $ from 'jquery';
window.$ = $;

var oneEvent = function(_element, event, action){
	setTimeout(function(){
		var _func = function(){
			_element.off(event, _func);
			action.apply(this, arguments);
		};
		_element.on(event, _func);
	}, 100);
};

const _body = $('body');

let _resizeMouseDown;

const popoverElements = (key) => {
  var $key = $("#" + key);
	return {
    popover: $key.find(".popover"),
  	popoverContainer: $key.find(".popover .popover-content"),
  	popoverArrow: $key.find(".popover .popover-arrow"),
  	editorContainer: $key,
  	resize: {
  		overlay: $key.find('.resizer-handle-overlay'),
  		background: $key.find('.resizer-handle-background'),
  		anchors: [
  			$key.find('.resizer-handle-corner.resizer-handle-corner-tl'),
  			$key.find('.resizer-handle-corner.resizer-handle-corner-tr'),
  			$key.find('.resizer-handle-corner.resizer-handle-corner-bl'),
  			$key.find('.resizer-handle-corner.resizer-handle-corner-br')
  		],
  		info: $key.find('.resizer-handle-info')
  	}
  }
}

export default class ImageBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      key: Date.now(),
      resizedDimension: {}
    };

    this._onClick = (e) => {
      var $el = $(e.target);
      this.showResizeOverlay($el);
      if (this.state.editMode) {
        return;
      }

      this.setState({
        editMode: true,
      }, () => {
        // this._startEdit();
      });
    };

    this.showPopover = (_el) => {
      const {key} = this.state;
			popoverElements(key).popover.css('display', 'block');
			this.reflowPopover(_el);
			popoverElements(key).popover.addClass('in');
			oneEvent($("html, body"), 'click keyup', () => {
				this.hidePopover();
			})
		}

    this.hidePopover = () => {
      const {key} = this.state;
			popoverElements(key).popover.css('display', '');
			popoverElements(key).popoverContainer.attr('style', '');
			popoverElements(key).popoverContainer.attr('class', 'popover-content');
			popoverElements(key).popover.removeClass('in');
		}

    this.reflowPopover = (_el) => {
      const {key} = this.state;
			var offsetTop = _el.offset().top - popoverElements(key).editorContainer.offset().top,
					offsetLeft = _el.offset().left - popoverElements(key).editorContainer.offset().left;
			if(popoverElements(key).editorContainer[0].offsetHeight - 51 > offsetTop){
				popoverElements(key).popover.css('top', offsetTop + _el[0].offsetHeight + popoverElements(key).editorContainer[0].scrollTop + 'px');
				popoverElements(key).popover.removeClass('top').addClass('bottom');
			} else {
				popoverElements(key).popover.css('top', offsetTop - 54 + popoverElements(key).editorContainer[0].scrollTop + 'px');
				popoverElements(key).popover.removeClass('bottom').addClass('top');
			}
			var _maxLeft = popoverElements(key).editorContainer[0].offsetWidth - popoverElements(key).popover[0].offsetWidth;
			var _targetLeft = offsetLeft + (_el[0].offsetWidth / 2.0) - (popoverElements(key).popover[0].offsetWidth / 2.0);
			popoverElements(key).popover.css('left', Math.max(0, Math.min(_maxLeft, _targetLeft)) + 'px');
			popoverElements(key).popoverArrow.css('margin-left', (Math.min(_targetLeft, (Math.max(0, _targetLeft - _maxLeft))) - 11) + 'px');
		}

    this.reflowResizeOverlay = (_el) => {
			const {key} = this.state;
			var offsetTop = _el.offset().top - popoverElements(key).editorContainer.offset().top,
					offsetLeft = _el.offset().left-popoverElements(key).editorContainer.offset().left;
			popoverElements(key).resize.overlay.css({
				'display': 'block',
				'left': offsetLeft - 5 + 'px',
				'top': offsetTop - 5 + 'px',
				'width': _el[0].offsetWidth + 10 + 'px',
				'height': _el[0].offsetHeight + 10 + 'px'
			});
			popoverElements(key).resize.info.html(_el[0].offsetWidth + ' x ' + _el[0].offsetHeight);
		}

    this.showResizeOverlay = (_el) => {
      const {key} = this.state;
      let newWidth = parseInt(_el.css('width')),
          newHeight = parseInt(_el.css('height')); 
			_resizeMouseDown = (event) => {
				var startPosition = {
					width: parseInt(_el.css('width')),
					height: parseInt(_el.css('height')),
					x: event.clientX,
					y: event.clientY
				};
				if(startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
				if(startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
				this.hidePopover();
				var ratio = startPosition.height / startPosition.width;
				var mousemove = (event) => {
					// calculate new size
					var pos = {
						x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
						y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
					};
					var keppRatio = event.shiftKey;
					if(keppRatio) {
						var newRatio = pos.y / pos.x;
						pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
						pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
					}
					// var el = angular.element(_el);
					function roundedMaxVal(val) {
						return Math.round(Math.max(0, val));
					}
					_el.css('height', roundedMaxVal(pos.y) + 'px');
					_el.css('width', roundedMaxVal(pos.x) + 'px');

          newWidth = roundedMaxVal(pos.x);
          newHeight = roundedMaxVal(pos.y);

					// reflow the popover tooltip
					this.reflowResizeOverlay(_el);
				};
				_body.on('mousemove', mousemove);
				oneEvent(_body, 'mouseup', (event) => {
					event.preventDefault();
					event.stopPropagation();
					_body.off('mousemove', mousemove);
					this.hidePopover();
				});
				event.stopPropagation();
				event.preventDefault();
			};

			popoverElements(key).resize.anchors[3].off('mousedown');
			popoverElements(key).resize.anchors[3].on('mousedown', _resizeMouseDown);

			this.reflowResizeOverlay(_el);
			oneEvent(_body, 'click', () => {
        this._onImageResize({width: newWidth, height: newHeight});
        this.hideResizeOverlay();
      });
		}

    this.hideResizeOverlay = () => {
      const {key} = this.state;
			popoverElements(key).resize.anchors[3].off('mousedown', _resizeMouseDown);
			popoverElements(key).resize.overlay.css('display', '');
		}

  }

  _onImageResize(dimension) {
    this.props.blockProps.onResizeImage(dimension);
  }

  _getValue() {
    return Entity
      .get(this.props.block.getEntityAt(0))
      .getData();
  }

  render() {
    var imageSrc = this._getValue()['src'],
        dimension = this._getValue()['dimension'];
    return (
      <div className="image-block" id={this.state.key}>
        <img
          alt="Block"
          src={imageSrc}
          onClick={this._onClick}
          style={{width: dimension && dimension.width ? (dimension.width + 'px') : 'auto',
            height: dimension && dimension.height ? (dimension.height + 'px') : 'auto'}}
            />
        <div className="popover fade top">
          <div className="popover-arrow"></div>
          <div className="popover-content"></div>
        </div>
        <div className="resizer-handle-overlay">
          <div className="resizer-handle-background"></div>
          <div className="resizer-handle-corner resizer-handle-corner-tl"></div>
          <div className="resizer-handle-corner resizer-handle-corner-tr"></div>
          <div className="resizer-handle-corner resizer-handle-corner-bl"></div>
          <div className="resizer-handle-corner resizer-handle-corner-br"></div>
          <div className="resizer-handle-info"></div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/TeXEditor/ImageBlock.js
 **/